// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1nlim","disabled":"FileBtn_disabled__1E1fM","warn":"FileBtn_warn__3mXdh","fade":"FileBtn_fade__DvxQS"};